// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPreferredSpecialty {
    static getAttributeTypeMap() {
        return MedicalBiPreferredSpecialty.attributeTypeMap;
    }
}
MedicalBiPreferredSpecialty.discriminator = undefined;
MedicalBiPreferredSpecialty.additionalProperties = false;
MedicalBiPreferredSpecialty.attributeTypeMap = [
    {
        "name": "pharmacy",
        "baseName": "pharmacy",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPreferredSpecialty.js.map